import React, { FC, useEffect, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { arrowright, dataLoading } from '../../assets/assets';
import httpApiCall from '../../service/api.service';
import { getStorageValue } from '../../service/shared.service';
import NoDataFound from '../NoDataFound/NoDataFound';
import "./faqs.scss"

const Faqs = () => {
   let [search_string, set_search_string] = useState('');
   const [faqs_data, set_faqs_data] = useState([]);
   const [shimmer, set_shimmer] = useState(false);
   const navigate = useNavigate();
   useEffect(() => {
      getFaqs();
   }, [])

   const getFaqs = async () => {
      const profile = getStorageValue('partnerProfile');
      const body = {
         access_token: profile && profile[0] && profile[0]['access_token'],
         search_string: search_string || undefined
      }
      set_shimmer(true);
      await httpApiCall({ api: "get_faq", type: "POST", body }).then(data => {
         set_shimmer(false);
         if (!data.is_error) {
            set_faqs_data(data.result);
         }
      })
   }
   
   return (
      <div className='right-wrapper'>
      <div className='faqs'>
         <div className="container">
         <div className='row'>
            <div className='col-12'>
               <span className='cursor d-none d-md-block' onClick={() => navigate("/app/support/")}>
                  <svg  width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9.57031 5.93018L3.50031 12.0002L9.57031 18.0702" stroke="#073c4f" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path><path d="M20.5 12H3.67" stroke="#073c4f" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path></svg>
               </span>
               <h3 className='text-center'>Frequently Asked Questions</h3>
               <div className='text-center m-4'>
                  <div className='position-relative d-inline-block'>
                     <input value={search_string} placeholder='Search' style={{ 'padding': '5px 30px 5px 5px', 'width': '220px', "border": "solid 1px #ccc", "borderRadius": "7px" }} type="text" onChange={(event: any) => set_search_string(event.target.value)} onKeyDown={(e: any) => {
                        if (e.key === "Enter") {
                           set_search_string(e.target['value']);
                           // search_string = e.target['value'];
                           getFaqs();
                        }
                     }} />
                     {!search_string && <span style={{'position': 'absolute', 'top': '5px', 'right': '7px'}} className="serch-btn navbar__search__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                           fill="none" className="">
                           <path
                              d="M13.8938 13.8676L17.5 17.5M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                              stroke="#DFE5ED" strokeWidth="1.5" strokeLinecap="round"
                              strokeLinejoin="round" />
                        </svg>
                     </span>}
                     {search_string && <span style={{'position': 'absolute', 'top': '5px', 'right': '7px'}} className="clear-btn navbar__search__icon" onClick={() => {
                        search_string = '';
                        set_search_string('');
                        getFaqs();
                     }}  >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                           fill="none">
                           <path d="M5.99023 13.3914L14.0086 5.60889" stroke="#CBD1D9" strokeWidth="1.5"
                              strokeLinecap="round" strokeLinejoin="round" />
                           <path d="M14.0086 13.3914L5.99023 5.60889" stroke="#CBD1D9" strokeWidth="1.5"
                              strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                     </span>}
                  </div>
               </div>
               {shimmer ? <div className="no_data_v2 text-center">
                  <img src={dataLoading} alt="" />
               </div> : <div className='result_faqs'>
                  {
                     faqs_data && faqs_data.length > 0 ? <Accordion alwaysOpen className='accordian'>
                        {
                           faqs_data.map((item, index) => (
                              <div key={index}>
                                 <Accordion.Item className='mb-3' eventKey={index + ''}>
                                    <Accordion.Header>{item['question']}</Accordion.Header>
                                    <Accordion.Body>
                                       {item['answer']}
                                    </Accordion.Body>
                                 </Accordion.Item>
                              </div>
                           ))
                        }
                     </Accordion> :
                        <div style={{ 'marginTop': '100px' }} className="nocompo d-block position-relative">
                           <NoDataFound />
                        </div>
                  }
               </div>}
            </div>
         </div>
         </div>
        
         </div>
         </div>
   )
}

export default Faqs;

